jQuery(document).ready(function ($) {
    $('a.gallery').featherlightGallery({
        previousIcon: '&#9664;',     /* Code that is used as previous icon */
		nextIcon: '&#9654;',         /* Code that is used as next icon */
        galleryFadeIn: 300,
        openSpeed: 300
    });
});